export default {
    active: 'aktiv',
    archived: 'archiviert',
    diverse: 'divers',
    draft: 'Entwurf',
    female: 'weiblich',
    guest: 'Gast',
    in_trial: 'Probemonat',
    male: 'männlich',
    monthly: 'monatlich',
    not_renewing: 'nicht verlängert',
    published: 'veröffentlicht',
    yearly: 'jährlich',
};
